import { useEffect, useState, useRef } from 'react';
import { CacheProvider } from '@emotion/react';
import { getMUICache, getImageUrl, getUrl, isLoggedIn, getEndpoint, setCmsSeoData, isCSR, isUpdatedWithin24Hours, getTimeAgo, getImageSize, getImageId } from '../../../common/utils';
import { SocialShareTwo } from '../SocialShareTwo/SocialShareTwo';
import parse from 'html-react-parser';
import './ampLiveBlog.css';
import { URL_PROTOCAL } from '../../Common/Constant';
import { Button } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

import { PAGEBUILDER_URLS } from '../../Common/Constant';
// import Poll from './poll';

ampLiveBlog.version = 1000;

ampLiveBlog.lang = 'en';
ampLiveBlog.langs = [
    'en'
];
ampLiveBlog.setLang = (lang: any) => {
    ampLiveBlog.lang = lang;
}

Object.defineProperty(ampLiveBlog, 'name', {
    writable: true,
    value: 'ampLiveBlog'

});

declare global {
    namespace JSX {
        interface IntrinsicElements {
            'amp-iframe': any;
            'amp-img': any;
            'amp-facebook': any;
            'amp-twitter': any;
            'amp-instagram': any;
        }
    }
}


// declare namespace JSX {
//     interface IntrinsicElements {
//       'amp-iframe': any;
//     }
//   }

export function ampLiveBlog(props: any) {

    const [imageIdObj, setImageIdObj] = useState<any>({});
    const [liveblogData, setLiveblogData] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [error] = useState(null);
    const [newUpdatesCount, setNewUpdatesCount] = useState(0);
    const [loadingUpdates, setLoadingUpdates] = useState(false);
    const currentCountRef = useRef(0);

    let REQUEST_HOSTNAME: any = null;
    if (props && props.REQUEST_HOSTNAME) {
        REQUEST_HOSTNAME = props.REQUEST_HOSTNAME;
    }

    let REQUEST_URL: any = null;
    if (props && props.REQUEST_URL) {
        REQUEST_URL = props.REQUEST_URL;
    }

    // Polling interval in milliseconds (10 seconds)
    const POLLING_INTERVAL = 10000;
    // Ref for polling interval
    const pollingIntervalRef = useRef<NodeJS.Timeout | null>(null);

    // Extract the child count from the API response
    const getChildCount = (data: any) => {
        if (Array.isArray(data?.response?.data) && data.response.data.length > 0 && data.response.data[0] && data.response.data[0].childcount) {
            return data.response.data[0].childcount;
        } else {
            return 0;
        }
    };

    const setCount = (count: any) => {
        if (count) {
            try{
                currentCountRef.current = count;
            } catch(e){
                console.log(e);
            }
            
        }
    };

    const addExportedData = (object: any) => {
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.pid !== "undefined"
            && object.parentid && object.parentid != "") {
            props.exportedKeys.pid = object.parentid;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.sectionid !== "undefined"
            && object.msid && object.msid != "") {
            props.exportedKeys.sectionid = object.msid;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.tags !== "undefined"
            && Array.isArray(object.keywords) && object.keywords.length > 0) {
            const names = object.keywords.map((item: any) => item.name).join(',');
            props.exportedKeys.tags = names;
        }
    }

    const endpoint = getEndpoint(props, "MAIN");
    const contentURL = getUrl(props, 1, false, 'MAIN', true, "", "", false);
    const countURL = getUrl(props, 1, false, 'MAIN', true, "", "", false).replace("/content/", "/count/");

    if (endpoint.isSSR && endpoint.SSRDataObj && liveblogData && Object.keys(liveblogData).length === 0
        && endpoint.SSRDataObj.response && Array.isArray(endpoint.SSRDataObj.response.data) && endpoint.SSRDataObj.response.data.length > 0) {
        setLiveblogData(endpoint.SSRDataObj.response.data[0]);
        addExportedData(endpoint.SSRDataObj.response.data[0]);
        setCount(getChildCount(endpoint.SSRDataObj));
        setCmsSeoData(props, endpoint.SSRDataObj.response.data[0], "LiveblogShow");
    }

    // Format timestamp to readable format with IST
    const formatDate = (timestamp: any, formatType: 'short' | 'long' = 'short') => {
        if (!timestamp) return '';

        const date = new Date(parseInt(timestamp));

        if (formatType === 'short') {
            // Format: 10:53 (IST) | Jun 03, 25
            const time = date.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });

            const dateStr = date.toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: '2-digit'
            });

            return `${time} (IST) | ${dateStr}`;
        }

        // Format: April 5, 2024, 12:11 PM (without "at")
        const datePart = date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        });

        const timePart = date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });

        return `${datePart}, ${timePart}`;
    };

    // Fetch the liveblog content
    const fetchLiveblogContent = async () => {
        try {
            const response = await fetch(contentURL, {
                method: 'GET',
                cache: 'no-store'
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error fetching liveblog content:', error);
            throw error;
        }
    };

    // Fetch the liveblog count data
    const fetchLiveblogCount = async () => {
        try {
            const response = await fetch(countURL, {
                method: 'GET',
                cache: 'no-store'

            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error fetching liveblog count:', error);
            throw error;
        }
    };

    // Check for updates
    const checkForUpdates = async () => {
        try {
            const countData = await fetchLiveblogCount();
            const newCount = getChildCount(countData);

            console.log(`Current count: ${currentCountRef?.current}, New count: ${newCount}`);

            if (newCount > currentCountRef?.current) {
                // New updates available
                setNewUpdatesCount(newCount - currentCountRef?.current);
            }
        } catch (error) {
            console.error('Error checking for updates:', error);
        }
    };

    // Handle notification button click
    const handleNotificationClick = async () => {
        try {
            // Show loading state
            setLoadingUpdates(true);

            // Fetch and display the latest content
            const data = await fetchLiveblogContent();
            setLiveblogData(data?.response?.data?.[0]);

            // Update the current count
            setCount(getChildCount(data));

            // Reset new updates count
            setNewUpdatesCount(0);
        } catch (error) {
            console.error('Error loading updates:', error);
            //setError('Failed to load updates. Try again.');
        } finally {
            setLoadingUpdates(false);
        }
    };

    // Load initial data
    useEffect(() => {
        const loadInitialData = async () => {
            setLoading(true);
            try {
                const data = await fetchLiveblogContent();
                setLiveblogData(data?.response?.data?.[0]);

                // Set initial child count
                setCount(getChildCount(data));
            } catch (error) {
                console.error('Error loading initial data:', error);
                //setError('Failed to load liveblog data. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            loadInitialData();
        }

        if (liveblogData && liveblogData.primeId) {
            isLoggedIn();
        }

        if (!(isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url)))) {
            // Start polling for updates
            pollingIntervalRef.current = setInterval(checkForUpdates, POLLING_INTERVAL);
            console.log('Polling started');

            // Clean up on unmount
            return () => {
                if (pollingIntervalRef.current) {
                    clearInterval(pollingIntervalRef.current);
                    console.log('Polling stopped');
                }
            };
        }
    }, []);

    useEffect(() => {
        let imageIdObj = {
            msid: liveblogData?.msid,
            thumbsize: liveblogData?.thumbsize
        }
        if (props.hostImageId && (!imageIdObj.msid || !imageIdObj.thumbsize)) {
            imageIdObj.msid =  getImageId(props.hostImageId);
            imageIdObj.thumbsize = getImageSize(props.hostImageId);
        }

        setImageIdObj(imageIdObj);
        
        renderLiveblogItems();
    }, [liveblogData]);

    const isLive = isUpdatedWithin24Hours(liveblogData?.metainfo?.LastPublishMilliTime?.value, liveblogData?.updatedate);

    // Render liveblog items
    const renderLiveblogItems = () => {
        if (!liveblogData || !liveblogData.children || liveblogData.children.length === 0) {
            return <div className='loader'>No updates available yet.</div>;
        }

        return liveblogData.children.map((item: any, index: number) => (
            <div className={`blogBlockWrapper ${index === 0 ? 'firstItem' : ''}`} key={item.msid || index}>

                {/* Render content based on cmstype */}
                {item.cmstype === "IMAGES" && (
                    <div className='insideBlogImageMainWrapper' id={`image-${item.msid}`}>
                        <div className='blogBlockDate'>{formatDate(item.updatedate)}</div>
                        <div className='imageBlogTitle blogBlockHeading'>{item.title || ''}</div>

                        <div className='insideBlogImagesWrapper'>
                            {item.thumbsize && item.msid && item.thumbsize > 0 &&
                                <div key={item.msid || index} className='insideBlogImage'>
                                    {/* <img src={getImageUrl(item.msid, item.thumbsize, 328, '', "", false, props.CONSTANTS)} alt={item.title} title={item.title} /> */}

                                    <amp-img
                                        src={getImageUrl(item.msid, item.thumbsize, 328, '', "", false, props.CONSTANTS)}
                                        alt={item.title}
                                        title={item.title}
                                        width="328" // Provide actual or aspect ratio width
                                        height="185" // Provide actual or aspect ratio height (e.g., 16:9 for 328 width)
                                        layout="responsive"
                                    >
                                    </amp-img>

                                </div>}
                            <div className='insideBlogSynopsis'>
                                {item.synopsis && (
                                    <p dangerouslySetInnerHTML={{ __html: item.synopsis || '' }}></p>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {item.cmstype === "TEXTSNIPPET" &&

                    <>
                        <div className='blogBlockDate'>{formatDate(item.updatedate)}</div>
                        <div className='text-snippet-container' id={`text-snippet-${item.msid}`}>
                            <div className='blogBlockHeading' dangerouslySetInnerHTML={{ __html: item.title || '' }} />
                            <div className='blogBlockContentWrapper'>
                                <p dangerouslySetInnerHTML={{ __html: item.synopsis || '' }} ></p>
                            </div>
                        </div></>
                }

                {item.cmstype === "QUOTES" &&
                    <div className='quote-container' id={`quote-${item.msid}`}>
                        <div className='time'>{formatDate(item.insertdate)}</div>
                        <div className='blogBlockContentWrapper quote'>
                            <div className="ampQuotsliveblog">"</div>
                            <p>{item.title}</p>
                        </div>
                        <div className='blogBlockContentWrapper quote-author'>{item.quotedby}</div>
                    </div>
                }
                {item.cmstype === "MEDIAVIDEO" && item?.media?.rmname === "youtube" &&
                    <div className='video-container' id={`video-${item.msid}`}>
                        <div className='time'>{formatDate(item.insertdate)}</div>
                        <div className='blogBlockHeading'>{item.title}</div>
                        <div>
                            <amp-iframe
                                width="640"
                                height="360"
                                layout="responsive"
                                sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                                // frameborder="0"
                                // allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                // referrerpolicy="strict-origin-when-cross-origin"
                                // allowfullscreen
                                title={item.title}
                                src={`https://tvid.in/e#skipad=false&apikey=denmarka5ec9705eb7ac2c984033f264&v=YT${item.media.id}&autoplay=0`}>
                            </amp-iframe>
                        </div>
                        <div className="blogBlockContentWrapper" dangerouslySetInnerHTML={{ __html: item.description || '' }} />
                    </div>
                }
                {item.cmstype === "MEDIAVIDEO" && item?.media?.rmname === "Kaltura" &&
                    <div className='video-container' id={`video-${item.msid}`}>
                        <div className='time'>{formatDate(item.insertdate)}</div>
                        <div className='blogBlockHeading'>{item.title}</div>
                        <div>

                            <amp-iframe
                                width="640"
                                height="360"
                                layout="responsive"
                                sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                                // frameborder="0"
                                // allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                // allowfullscreen
                                title={item.title}
                                src={`https://tvid.in/e#skipad=false&apikey=denmarka5ec9705eb7ac2c984033f264&v=${item.media.id}&autoPlay=0`}>

                            </amp-iframe>

                        </div>
                        <div className='blogBlockContentWrapper' dangerouslySetInnerHTML={{ __html: item.synopsis || '' }} />
                    </div>
                }

                {item.cmstype === "MEDIAAUDIO" && item?.media?.rmname && (
                    <>
                    {item.media.rmname === "youtube" && item.media.id && (
                        <div className='audio-container youtube-audio-embed' id={`audio-yt-${item.msid}`}>
                            <div className='time'>{formatDate(item.insertdate)}</div>
                            <div className='blogBlockHeading'>{item.title}</div>
                            <div>
                                <amp-iframe
                                    width="640"
                                    height="360" // Adjusted height for audio player
                                    layout="responsive"
                                    sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                                    src={`https://tvid.in/e#skipad=false&apikey=denmarka5ec9705eb7ac2c984033f264&v=YT${item.media.id}&autoplay=0`}
                                    title={item.title || 'YouTube Audio Player'}
                                    //allowfullscreen
                                >
                                </amp-iframe>
                            </div>
                            {item.synopsis && <div className='blogBlockContentWrapper' dangerouslySetInnerHTML={{ __html: item.synopsis }} />}
                        </div>
                    )}
                    </>
                )}

                {item.cmstype === "MEDIAAUDIO" && item?.media?.rmname === "Kaltura" && item.media.id && (
                    <div className='audio-container' id={`audio-kaltura-${item.msid}`}>
                        <div className='time'>{formatDate(item.insertdate)}</div>
                        <div className='blogBlockHeading'>{item.title}</div>
                        <div>
                            <amp-iframe
                                width="640"
                                height="360" // Adjusted height for audio player
                                layout="responsive"
                                sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                                src={`https://tvid.in/e#skipad=false&apikey=denmarka5ec9705eb7ac2c984033f264&v=${item.media.id}&autoPlay=0`}
                                title={item.title || 'Kaltura Audio Player'}
                               // allowfullscreen
                            >
                            </amp-iframe>
                        </div>
                        {item.synopsis && <div className='blogBlockContentWrapper' dangerouslySetInnerHTML={{ __html: item.synopsis }} />}
                    </div>
                )}

                {/* {item.cmstype === "POLL" && item.polloptions && (
                    <Poll
                        item={item}
                        CONSTANTS={props.CONSTANTS}
                        formatDate={formatDate}
                    />
                )} */}
                {item.cmstype === "SLIDE" &&
                    item?.embeds?.[0]?.type === "javascript" &&
                    item?.embeds?.[0]?.title === "Twitter" &&
                    (() => {
                        let tweetId = '';

                        // Prioritize tweet ID from embeds if available
                        if (item.embeds?.[0]?.id && item.embeds?.[0]?.type === 'Twitter') {
                            tweetId = item.embeds[0].id;
                        } else if (item.text) {
                            const cdataMatch = item.text.match(/<cdata>\s*<!\[CDATA\[([\s\S]*?)\]\]>\s*<\/cdata>/i);
                            if (cdataMatch && cdataMatch[1]) {
                                const htmlContent = cdataMatch[1].trim();
                                // Try to extract tweet ID from a URL in the blockquote
                                const statusMatch = htmlContent.match(/twitter\.com\/[^/]+\/status\/(\d+)/);
                                if (statusMatch && statusMatch[1]) {
                                    tweetId = statusMatch[1];
                                }
                            }
                        }

                        if (tweetId) {
                            return (
                                <div className="twitter-embed-container" id={`twitter-embed-${item.msid}`}>
                                    <div className='time'>{formatDate(item.insertdate)}</div>
                                    {item.title && (
                                        <div className='blogBlockHeading'>
                                            {item.title}
                                        </div>
                                    )}
                                    <amp-twitter
                                        width="375" // Default width, adjust as needed
                                        height="472" // Default height, adjust as needed
                                        layout="responsive"
                                        data-tweetid={tweetId}
                                    >
                                    </amp-twitter>
                                </div>
                            );
                        }
                        console.warn("AMP LiveBlog: Could not extract Tweet ID for item:", item.msid, item.text, item.embeds);
                        return null;
                    })()

                }

                {item.cmstype === "SLIDE" && item?.embeds?.[0]?.type === "javascript" && item?.embeds?.[0]?.title === "Facebook" && (() => {
                    let facebookPostUrl = '';

                    if (item.text) {
                        const cdataMatch = item.text.match(/<cdata>\s*<!\[CDATA\[([\s\S]*?)\]\]>\s*<\/cdata>/i);
                        if (cdataMatch && cdataMatch[1]) {
                            const htmlContent = cdataMatch[1].trim();
                            let postUrl = '';

                            // 1. Try to find a URL within an iframe src
                            const iframeSrcMatch = htmlContent.match(/<iframe[^>]+src="([^"]+)"/i);
                            if (iframeSrcMatch && iframeSrcMatch[1]) {
                                const srcUrl = iframeSrcMatch[1];
                                // Check if it's a Facebook plugin URL and extract the actual post href
                                const pluginHrefMatch = srcUrl.match(/href=([^&]+)/i);
                                if (srcUrl.includes('facebook.com/plugins/') && pluginHrefMatch && pluginHrefMatch[1]) {
                                    try {
                                        postUrl = decodeURIComponent(pluginHrefMatch[1]);
                                    } catch (e) {
                                        console.error("AMP LiveBlog: Error decoding Facebook URL from plugin: ", pluginHrefMatch[1], e);
                                    }
                                } else if (srcUrl.includes('facebook.com')) {
                                    // If src is a direct facebook post URL (less common for iframes but possible)
                                    postUrl = srcUrl;
                                }
                            }

                            // 2. If not found in iframe src, try to find a URL within an anchor href
                            if (!postUrl) {
                                const anchorHrefMatch = htmlContent.match(/<a[^>]+href="([^"]*facebook\.com\/[^"]+)"/i);
                                if (anchorHrefMatch && anchorHrefMatch[1]) {
                                    postUrl = anchorHrefMatch[1];
                                }
                            }

                            // 3. If not found yet, check if the content itself is a Facebook URL
                            if (!postUrl && /^(https?:\/\/)?(www\.)?facebook\.com\/.+/i.test(htmlContent)) {
                                postUrl = htmlContent;
                            }

                            if (postUrl) {
                                facebookPostUrl = postUrl;
                            }
                        }
                    }

                    if (facebookPostUrl) {
                        return (
                            <div className='facebook-cdata-container' id={`facebook-cdata-${item.msid}`}>
                                <div className='time'>{formatDate(item.insertdate)}</div>
                                <div className='blogBlockHeading'>{item.title}</div>
                                <amp-facebook
                                    width="400" // Adjusted for a more standard post aspect ratio
                                    height="580" // Increased height to better accommodate post content
                                    layout="responsive"
                                    data-href={facebookPostUrl}>
                                </amp-facebook>
                            </div>
                        );
                    }
                    console.warn("AMP LiveBlog: Could not extract Facebook post URL for item:", item.msid, item.text);
                    return null;
                })()}
                {item.cmstype === "SLIDE" &&
                    item?.embeds?.[0]?.type === "javascript" &&
                    item?.embeds?.[0]?.title === "Instagram" &&
                    (() => {
                        let shortcode = '';

                        if (item.text) {
                            const cdataMatch = item.text.match(/<cdata>\s*<!\[CDATA\[([\s\S]*?)\]\]>\s*<\/cdata>/i);
                            if (cdataMatch && cdataMatch[1]) {
                                const content = cdataMatch[1].trim();
                                // Extract shortcode from URL: https://www.instagram.com/(p|reel)/SHORTCODE/
                                const shortcodeMatch = content.match(/instagram\.com\/(?:p|reel)\/([a-zA-Z0-9_-]+)/);
                                if (shortcodeMatch && shortcodeMatch[1]) {
                                    shortcode = shortcodeMatch[1];
                                }
                            }
                        }

                        if (shortcode) {
                            return (
                                <div className="instagram-embed-container" id={`instagram-embed-${item.msid}`}>
                                    <div className='time'>{formatDate(item.insertdate)}</div>
                                    {item.title && (
                                        <div className='blogBlockHeading'>
                                            {item.title}
                                        </div>
                                    )}
                                    <amp-instagram
                                        data-shortcode={shortcode}
                                        width="320" // A standard mobile-friendly width
                                        height="520" // Increased height to provide more vertical space
                                        layout="responsive"
                                    >
                                    </amp-instagram>
                                </div>
                            );
                        }
                        // console.warn("AMP LiveBlog: Could not extract Instagram shortcode for item:", item.msid, item.text);
                        return null;
                    })()}

            </div>
        ));
    };

    return (
        <CacheProvider value={getMUICache()}>
            <div>

                <div className='liveBlogHeadingBox'>
                    <div className={`liveBlogCommonLiveHeading ${isLive ? "liveBlogAnimationHeading" : "liveBlogNoneAnimationHeading"}`}>
                        {isLive && <i></i>}
                        Live Blog{' '}
                        {isLive && (
                            <span className='blogUpdateTime'>Updated {getTimeAgo(liveblogData?.metainfo?.LastPublishMilliTime?.value, liveblogData?.updatedate)}</span>
                        )}
                    </div>
                </div>
                <div className='liveBlogMainHeadingWrapper'>
                    {liveblogData && (
                        <div className='liveBlogMainHeading'>
                            {liveblogData.title || 'Live Updates'}
                        </div>
                    )}
                </div>

                <div className='showmaintime'>
                    {/* {formatDate(liveblogData.insertdate)} | Updated:  */}
                    {liveblogData ? formatDate(liveblogData.updatedate, 'long') : ''}
                    {/* {liveblogData.agency?.id || 'NA'} */}
                </div>
                <div className='liveBlogSocialIcons blogShowMobileSocial'>
                    <SocialShareTwo
                        shareUrl={URL_PROTOCAL + REQUEST_HOSTNAME + REQUEST_URL}
                        showFacebook={true}
                        showTwitter={true}
                        showLinkedin={true}
                        showWhatsapp={true}
                        showPintrest={true} />
                </div>

                <div className="liveBlogSynopsisImageWrap">
                    <div className='ThemeThreeRecentImageWrap'>
                        {imageIdObj && imageIdObj.thumbsize && (
                            <>
                                {(typeof document !== 'undefined' && undefined !== document && document
                                    && PAGEBUILDER_URLS.some(domain => window.location.origin.includes(domain))) ? (
                                    <img
                                        alt={liveblogData.title}
                                        title={liveblogData.title}
                                        src={getImageUrl(imageIdObj.msid, imageIdObj.thumbsize, 764, '', "", false, props.CONSTANTS)}
                                        width={430}
                                        height={242}
                                    />
                                ) : (
                                    <amp-img
                                        alt={liveblogData.title}
                                        title={liveblogData.title}
                                        src={getImageUrl(imageIdObj.msid, imageIdObj.thumbsize, 764, '', "", false, props.CONSTANTS)} // Using larger image as primary
                                        width="430" // Provide actual or aspect ratio width
                                        height="242" // Provide actual or aspect ratio height (e.g., 16:9 for 764 width)
                                        layout="responsive"
                                    >
                                    </amp-img>
                                )}
                            </>
                        )}
                    </div>
                    {liveblogData?.mobilesynopsis && (
                        <div className="liveBlogSynopsisWrap">
                            <p>
                                <strong>Synopsis:</strong>{" "}
                                <span
                                    dangerouslySetInnerHTML={{ __html: liveblogData.mobilesynopsis }}
                                />
                            </p>
                        </div>
                    )}
                </div>
                <div className='liveBlogMainContentWrap'>
                    <div className='liveBlogSocialIcons blogShowDesktopSocial'>
                        <SocialShareTwo
                            shareUrl={URL_PROTOCAL + REQUEST_HOSTNAME + REQUEST_URL}
                            showFacebook={true}
                            showTwitter={true}
                            showLinkedin={true}
                            showWhatsapp={true}
                            showPintrest={true} />
                    </div>
                    <div className='liveBlogSummeryWrap'>
                        {liveblogData && liveblogData?.synopsis && (
                            <div className='liveBlogBigSynopsis'>{parse(liveblogData?.synopsis)}</div>
                        )}
                        <div className='liveBlogWrapper'>
                            {newUpdatesCount > 0 && (
                                <Button className='notificationButton'
                                    onClick={handleNotificationClick}
                                    disabled={loadingUpdates}
                                    endIcon={!loadingUpdates && <RefreshIcon />}
                                >
                                    {loadingUpdates
                                        ? 'Loading updates...'
                                        : `${String(newUpdatesCount).padStart(2, '0')} new update${newUpdatesCount > 1 ? 's' : ''}`}
                                </Button>
                            )}
                            {loading && <div className='loader'>Loading liveblog data...</div>}
                            {error && <div className='error'>{error}</div>}
                            {!loading && !error && renderLiveblogItems()}
                        </div>
                    </div>

                </div>

            </div>
        </CacheProvider>
    )
}
